"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingDetail = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const typeorm_1 = require("typeorm/browser");
const question_1 = require("./question");
const rating_1 = require("./rating");
let RatingDetail = class RatingDetail {
};
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", String)
], RatingDetail.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)('int', {
        default: 0,
        name: 'value',
    }),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.Max)(10),
    __metadata("design:type", Number)
], RatingDetail.prototype, "value", void 0);
__decorate([
    (0, typeorm_1.Column)('int', {
        default: 100,
        name: 'weight',
    }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.Max)(10000),
    __metadata("design:type", Number)
], RatingDetail.prototype, "weight", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        name: 'title',
        length: 255,
    }),
    __metadata("design:type", String)
], RatingDetail.prototype, "title", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        nullable: false,
        name: 'question',
    }),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], RatingDetail.prototype, "text", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => rating_1.Rating, (rating) => rating.items, {}),
    (0, typeorm_1.JoinColumn)({ name: 'rating_id' }),
    __metadata("design:type", rating_1.Rating)
], RatingDetail.prototype, "rating", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.Column)({
        type: 'bigint',
        name: 'question_id',
    }),
    __metadata("design:type", String)
], RatingDetail.prototype, "questionId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => question_1.Question, (question) => question.items, {}),
    (0, typeorm_1.JoinColumn)({ name: 'question_id' }),
    __metadata("design:type", question_1.Question)
], RatingDetail.prototype, "question", void 0);
RatingDetail = __decorate([
    (0, typeorm_1.Entity)('rating_detail', { schema: 'rating' })
], RatingDetail);
exports.RatingDetail = RatingDetail;
//# sourceMappingURL=rating-detail.js.map